<template>
    <div class="create-order-main">
        <div class="order-detail">
            <div class="divnull"></div>
            <div class="order-address">
                <div class="addres-box" @click="goAddress">
                    <p v-if="!(address&&address.username)" class="address-null">
                        <i class="addres-null-icon"></i>
                        <span class="">{{$t("shop.shipAddress")}}</span>
                    </p>
                    <template v-else>
                        <p class="user-infor" >
                            <span class="name">{{address.username}}</span>
                            <span class="phone">{{address.tel}}</span>
                        </p>
                        <p class="address-text">
                            <i class="text-icon"></i>
                            <span class="txt">{{address.province+address.city+address.district+address.street}}</span>
                        </p>
                    </template>
                </div>
                <i class="more-icon"></i>
            </div>
            <div class="divnull"></div>
            <div class="order-goods">
                <div class="goods-list">
                    <div class="goods-item" v-for="(item,index) in createData" :key="index">
                        <div class="goods-details" >
                            <div class="goods-img" @click="goGoodsDetails(item)">
                                <img :src="item.pryImgUrl">
                            </div>
                            <div class="goods-infor" >
                                <!-- <p class=""></p> -->
                                <div class="infor-text" @click="goGoodsDetails(item)">
                                    <p class="txt"><span class="discount-tag" v-if="item.discountId">{{item.discountTag}}</span> {{item.name}}</p>
                                    <div class="describe" >

                                        <span v-for="(citem,cindex) in item.specAndValues" :key="cindex">{{citem.valueName}}{{cindex == item.specAndValues.length-1?'':','}}</span>
                                    </div>
                                    <p class="back-integarl" v-if="item.rewardPoints!=0&&item.rewardPoints!=null">
                                        <span class="back">{{$t("shop.returnText")}}</span>
                                        <span class="icon"></span>
                                        <span class="num">{{item.rewardPoints}}</span>
                                    </p>
                                </div>
                                <p class="price" @click="goGoodsDetails(item)">
                                  {{$t("page.unitYuan")}}<span>{{item.sellPrice}}</span>
                                    <span class="good-num">x{{item.goodsQty}}</span>
                                </p>
                            </div>
                        </div>
                        <p class="supply-info" v-if="item.needUserInfo == 1" @click="perfectInfo(item, index)">
                            <span class="label">{{$t("shop.personalInfo")}}</span>
                            <span class="info-warning">
                                <van-icon name="warning-o" />
                                <span >{{item.infoObjName?item.infoObjName:'需'+$t("shop.personalInfo")}}</span>
                            </span>
                        </p>
                        <!-- <div class="goodsNum goods-collcapse">
                            <span class="lable">
                                购买数量
                            </span>
                            <div class="collcapse" align="right">
                                <div class="num-box">

                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="integral goods-collcapse" v-if="disCount>0">
                    <p class="lable">
                        {{$t("shop.shopDiscount")}}
                        <span>{{$t("shop.fullNameSpokesman")}}</span>
                    </p>
                    <div class="collcapse" align="right">
                        <span class="text" style="color:#FF5252">-{{$t("page.unitYuan")}}{{disCount}}</span>
                        <i class="integral-icon"></i>
                    </div>
                </div>

            </div>
            <div class="divnull"></div>
            <div class="order-goods">
                <div class="integral goods-collcapse">
                    <span class="lable">
                        {{$t("shop.requiredIntegral")}}
                    </span>
                    <div class="collcapse" align="right">
                        <span class="text integtext" :class="{'integtext':integral}">{{integral?$t('shop.need')+integral+' '+$t("shop.integral"):'0 '+$t("shop.integral")}}</span>
                        <i class="integral-icon"></i>
                    </div>
                </div>
                 <div class="integral goods-collcapse goods-coupon" v-if="couponList&&couponList.length != 0">
                    <span class="lable">
                        {{$t("shop.coupon")}}
                    </span>
                    <div class="collcapse" align="right" @click="selectCoupon">
                        <span class="coupon" :class="{'coupon-tag':couponObj.couponDefId}">
                            {{!couponObj.couponDefId?$t("shop.availableCoupons"):((couponObj.thresholdType == 162002?'满'+couponObj.thresholdMoney+'元':'')+'减'+couponObj.discount)}}
                        </span>
                        <van-icon name="arrow" class="arrow" />
                    </div>
                </div>
            </div>
            <div class="divnull"></div>
            <div class="order-leave-msg">
                <div class="msg-item">
                    <span class="lable">{{$t("shop.buyerMsg")}}：</span>
                    <div class="msg-section">
                        <van-field
                            v-model="userRemark"
                            rows="1"
                            maxlength="100"
                            autosize
                            type="text"
                            :placeholder="$t('shop.leaveWord')"
                        />
                    </div>
                </div>
                <div class="msg-item bill">
                    <span class="lable">{{$t("shop.billInfor")}}</span>
                    <div class="msg-section" @click="goBill">
                       <span class="txt">{{$t("shop.relationService")}}</span>
                       <van-icon name="arrow" class="arrow" />
                    </div>
                </div>
            </div>
        </div>
        <div class="order-pay">
            <p class="total">
                <span class="text">{{$t("shop.summation")}}：</span>
                <span class="unit">{{$t("page.unitYuan")}}&nbsp;</span>
                <span class="price">{{orderPrice}}</span>
            </p>
            <span class="flex"></span>
            <div class="submit" @click="ToPay">
                {{$t("shop.toPay")}}
            </div>
        </div>
        <van-overlay :show="payShow" class-name="payWapper">
            <div class="wapper">
                <div id="qrcode" class="qrcode" ref="qrcode"></div>
            </div>
            <div class="bnt-close" @click="gorderDetail">{{$t("shop.havePay")}}</div>
        </van-overlay>
        <van-overlay :show="InfoShow" class-name="InfoWapper" :lock-scroll="false">
            <div class="emtry" @click="InfoShow = false,OverlayForm= []"></div>
            <div class="info-container">
                <div class="info-head">
                    <span >{{$t("shop.perfectInfo")}}</span>
                    <i class="icon" @click="InfoShow = false,OverlayForm= []"></i>
                </div>
                <div class="from-container">
                    <div class="from-item" v-for="(item, index) in OverlayForm" :key="index">
                        <p class="title">
                            <i class="icon"></i>
                            <span class="txt">{{$t("shop.goods")}}{{index+1}}</span>
                        </p>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.fullName")}}</span>:
                            <div class="value">
                                <van-field v-model="item.userName" :placeholder="$t('shop.pleaseenter')" />
                            </div>                            
                        </div>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.phone")}}</span>:
                            <div class="value">
                                <van-field v-model="item.userTel" @blur="vailPhone(item.userTel)" :maxlength="11" :placeholder="$t('shop.pleaseenter')" />
                            </div>                            
                        </div>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.gender")}}</span>:
                            <div class="value gender">
                                <p class="gender-itme" :class="{'genderActive':item.userGender==1}"  @click="item.userGender = 1">
                                    <i class=""></i>
                                    <span>{{$t("shop.man")}}</span>
                                </p>
                                <p class="gender-itme" :class="{'genderActive':item.userGender==2}"  @click="item.userGender = 2">
                                    <i class=""></i>
                                    <span>{{$t("shop.woman")}}</span>
                                </p>
                                <!-- <van-field v-model="item.userName" :placeholder="$t('shop.pleaseenter')" /> -->
                            </div>                            
                        </div>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.Age")}}</span>:
                            <div class="value">
                                <van-field v-model="item.userAge" type="digit" :maxlength="3"  :placeholder="$t('shop.pleaseenter')" />
                            </div>
                            岁
                        </div>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.certificatesType")}}</span>:
                            <div class="value" @click="IDTypeShow = true,cIndex = index">
                                <van-field :value="item.userIdTypeName"   readonly :placeholder="$t('shop.pleaseenter')" />
                            </div>
                            <i class="icon"></i>
                        </div>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.certificatesNumber")}}</span>:
                            <div class="value">
                                <van-field v-model="item.userIdCode" @blur="idCodeChange(item)" :placeholder="$t('shop.pleaseenter')" />
                            </div>                            
                        </div>
                        <div class="from-input-item">
                            <span class="label">{{$t("shop.isMarriage")}}</span>:
                            <div class="value gender">
                                <p class="gender-itme" :class="{'genderActive':item.userMarry===1}"  @click="item.userMarry = 1">
                                    <i class=""></i>
                                    <span>是</span>
                                </p>
                                <p class="gender-itme" :class="{'genderActive':item.userMarry===0}"  @click="item.userMarry = 0">
                                    <i class=""></i>
                                    <span>否</span>
                                </p>
                            </div>                            
                        </div>
                    </div>
                </div>
                <div class="bottom-btn">
                    <p class="btn" @click="Infoconfrim">确定</p>
                </div>
            </div>
        </van-overlay>
        <my-overlay :show="IDTypeShow" :showField="'IDTypeShow'">
            <van-picker
                :title='$t("patient.pleaseselect")'
                show-toolbar
                slot="overBox"
                :default-index="idIndex"
                :columns="IdColumns"
                @confirm="onIdtypeConfirm"
                @cancel="IDTypeShow = false"
            />
        </my-overlay>
        <van-overlay :show="couponOverlayShow" :lock-scroll="false">
            <div class="specsOverlay courtesy-overlay">
                <div class="overlay-close" @click="couponOverlayShow = false"></div>
                <div class="overlay-box">
                    <div class="specs-head">
                        <p class="name">{{$t("shop.courtesyCard")}}</p>
                        <i class="close-icon" @click="couponOverlayShow = false"></i>
                    </div>
                    <div class="courtesy-list">
                        <div class="item-courtesy  flexC"  v-for="(item,index) in couponList" :key="index" @click="confirmCoupon(item)">
                            <div class="item-left flexC">
                                <div class="courtesy-money" :class="(typeof item.discount === 'number')&&(item.discount+'').length>3?'maxMonery':''">
                                    <p class="moeny-num"><span>¥</span>{{item.discount}}</p>
                                    <p class="condition">
                                        {{item.thresholdType == 162002?'满'+item.thresholdMoney+'元可使用':$t("shop.noSill")}}
                                    </p>
                                </div>
                                <div class="hr-line"></div>
                                <div class="courtesy-info-text">
                                    <p class="name">{{item.name}}</p>
                                    <p class="expiration-date">有效期至{{item.validEt}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { goodsDetail, addressList, orderCreate, WxPay, couponQuery } from "@/api/shop";
// 二维码
import QRCode from 'qrcodejs2'
import { IdColumns as IDCodeType, columns } from "@/utils/staticData"
import myOverlay from "@/components/myoverlay"
import { isIDCard, isPhoneNumber } from "@/utils/vaildate";
export default {
    components:{myOverlay},
    data() {
        return {
            // 优惠券弹窗
            couponOverlayShow:false,
            IDTypeShow:false,
            idIndex:null,
            InfoShow:false,
            payShow:false,
            goods:[],
            createData:{},
            address:{},
            IdColumns:[],
            addressList:[],
            userRemark:"",
            orderId:'',
            disCount:0,
            integral:0,
            // addressData:{}
            // 弹窗 完善信息对象、
            OverlayForm:[],
            editIndex:null,
            cIndex:null,
            isPhoneNumber,
            // 优惠券列表
            couponList:[],
            couponObj:{},
            // 是否有虚拟，真实商品(虚拟商品不需要填写地址)
            addressType:false
        }
    },
    computed:{
        orderPrice:function(){
            let orderPrice = 0;
            for(let i=0;i<this.createData.length;i++){
                orderPrice += (this.createData[i].sellPrice*this.createData[i].goodsQty);
                orderPrice -= (this.createData[i].distributionMinus==null?0:this.createData[i].distributionMinus*this.createData[i].goodsQty);
                this.disCount += (this.createData[i].distributionMinus==null?0:this.createData[i].distributionMinus*this.createData[i].goodsQty)
                this.integral += (this.createData[i].sellPoints == null?0:this.createData[i].sellPoints*this.createData[i].goodsQty)
            }
            if(this.couponObj.id){
                orderPrice = ((orderPrice - this.couponObj.discount)<0?0:(orderPrice - Number(this.couponObj.discount)));
            }
            return Number.isInteger(orderPrice)?orderPrice: orderPrice.toFixed(2);
        },
    },
    created(){
        IDCodeType.pop();
        this.IdColumns = IDCodeType;
        
        this.goods = JSON.parse(this.$route.query.goods);
        this.getGoodsDetail();
        this.getCoupon();
        if(localStorage.getItem('addressItem')){
            this.address = JSON.parse(localStorage.getItem('addressItem'));
        }else{
            this.getAddressList();
        }
        document.title = this.$t('shop.placeOrder');

    },
    beforeRouteLeave(to,from, next) {
        if(!(to.path.indexOf('address-list')>-1)){
            if(localStorage.getItem('addressItem')){
                localStorage.removeItem('addressItem');
            }
            if(localStorage.getItem('OverlayForm')){
                localStorage.removeItem('OverlayForm');
            }
        }
        if((to.path.indexOf('address-list')>-1)){
            // OverlayForm
            let infoFrom = {};
            for (let i = 0; i < this.createData.length; i++) {
                const it = this.createData[i];
                if(it.users&&it.users.length!=0){
                    infoFrom[it.id] = {users:it.users,infoObjName:it.infoObjName};
                }
            }
            if(JSON.stringify(infoFrom) != '{}'){
                localStorage.setItem("OverlayForm",JSON.stringify(infoFrom))
            }
        }
        next();
    },
    methods:{
        async getGoodsDetail(){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            let datadd = this.goods;
            let result = await goodsDetail(datadd);
            toast.clear();
            if(result.data.errorCode == 0){
                let obj;
                if(localStorage.getItem("OverlayForm")){
                    obj = JSON.parse(localStorage.getItem("OverlayForm"));
                }
                for (let i = 0; i < result.data.data.length; i++) {
                    for (let j = 0; j < datadd.length; j++) {
                        if(result.data.data[i].id == datadd[j].goodsId){
                            result.data.data[i].goodsQty = datadd[j].goodsQty;
                            result.data.data[i].infoObjName = '';
                        }
                    }
                    // 判断是否为虚拟商品  122002 
                    if(result.data.data[i].goodsType == 122001){
                        this.addressType = true;
                    }
                    if(obj&&JSON.stringify(obj) != '{}'){
                        result.data.data[i].infoObjName = obj[result.data.data[i].id].infoObjName;
                        result.data.data[i].users = obj[result.data.data[i].id].users;
                    }
                }
                this.createData = result.data.data;
            }else{
                this.$toast.fail(this.$t("shop.queryGoodsFail"));
            }
        },
        // 验证手机号
        vailPhone(phone){
            if(!isPhoneNumber(phone)&&phone){
                this.$toast(this.$t("message.TelFormatError"))
                return false;
            }
        },
        // 选择优惠券
        selectCoupon(){
            this.couponOverlayShow = true;
        },
        confirmCoupon(item){
            this.couponObj = item;
            this.couponOverlayShow = false;
        },
        // 获取优惠券
        getCoupon(){
            let datadd = this.goods;
            couponQuery({items:datadd}).then(result =>{
                if(result.data.errorCode == 0){
                    this.couponList = result.data.data;
                }
            })
        },
        onIdtypeConfirm(e,$index){
            this.OverlayForm[this.cIndex].userIdType = e.value;
            this.OverlayForm[this.cIndex].userIdTypeName = e.text;
            this.IDTypeShow = false;
        },
        idCodeChange(item){
            if(item.userIdType == 142001){
                if(!isIDCard(item.userIdCode)&&item.userIdCode){
                    this.$toast(this.$t("message.IDCodeFormatError"))                    
                }
            }
        },
        perfectInfo(item,index){
            this.editIndex = index;
            if(!item.users){
                this.OverlayForm = [];
                for (let i = 0; i < item.goodsQty; i++) {
                    this.OverlayForm.push({
                        name:item.name,
                        userName:"",
                        userGender:1,
                        userAge:"",
                        userIdType:142001,
                        userIdCode:"",
                        userTel:"",
                        userMarry:0,
                        userIdTypeName:"身份证"
                    }) 
                }
            }else{
                this.OverlayForm = item.users;
            }
            this.InfoShow = true;
            // this.OverlayForm 
        },
        gorderDetail(){
            this.$router.push({
                path:"/shop/order-detail",
                query:{
                    ...this.$route.query,
                    orderId:this.orderId,
                }
            })
        },
        Infoconfrim(){
            let strName = '';
            for (let i = 0; i < this.OverlayForm.length; i++) {
                const it = this.OverlayForm[i];
                strName += (i!=0?',':'') + it.userName  ;
                if(!it.userName){
                    this.$toast(this.$t("shop.pleaseenter")+this.$t("shop.fullName"));
                    return false
                }
                if(!it.userTel){
                    this.$toast(this.$t("shop.pleaseenter")+this.$t("shop.phone"));
                    return false
                }
                if(!it.userAge){
                    this.$toast(this.$t("shop.pleaseenter")+this.$t("shop.Age"));
                    return false
                }
                if(!it.userIdType){
                    this.$toast(this.$t("shop.pleaseSelect")+this.$t("shop.certificatesType"));
                    
                    return false
                }
                if(!it.userIdCode){
                    this.$toast(this.$t("shop.pleaseenter")+this.$t("shop.certificatesNumber"));
                    return false
                }
                if(!it.userMarry&&it.userMarry != 0){
                    this.$toast(this.$t("shop.pleaseSelect")+this.$t("shop.isMarriage"));
                    return false
                }                
                if(it.userIdType == 142001){
                    if(!isIDCard(it.userIdCode)&&it.userIdCode){
                        this.$toast(this.$t("message.IDCodeFormatError"))                    
                        return false
                    }
                }
            }
            
            this.createData[this.editIndex].users = this.OverlayForm;
            this.createData[this.editIndex].infoObjName = strName;
            this.InfoShow = false;
        },
        // 数量修改
        setGoodsNum(type,index){
            if(type==1){
                if(this.createData[index].goodsQty == 1){
                    return false;
                }
                this.createData[index].goodsQty -- ;
            }else{
                this.createData[index].goodsQty ++ ;
            }
        },
        // 去地址列表
        goAddress(){
            this.$router.push({
                path:'address-list',
                query:{
                    selectType:1
                }
            })
        },
        // 获取地址列表 replace
        async getAddressList(){
            let datadd = {}
            let result = await addressList(datadd);
            if(result.data.errorCode == 0){
                for(let i=0;i<result.data.data.length;i++){
                    if(result.data.data[i].isDefault == 1){
                        this.address = result.data.data[i];
                    }
                }
            }
        },
        goBill(){
            this.$router.push({
                path:"/im/chat",
                query:{
                    fromPage:120016,
					objId:this.orderId
                }
            })
        },
        // 查看商品详情
        goGoodsDetails(item){
             this.$router.push({
                path:"/shop/goods-detail",
                query:{
                    ...this.$route.query,
                    goodsId:item.id
                }
            })
        },
        // 去支付
        async ToPay(){
            if(!this.address.username&&this.addressType){
                this.$toast(this.$t('shop.addressWarning'));
                return false;
            }
            if(this.createData.length == 0){
                this.$toast(this.$t('shop.dataException'));
                return false;
            }
            if(this.$store.getters.points < this.integral){
                this.$toast(this.$t("shop.lackintegral"))
                return
            }
            for (let i = 0; i < this.createData.length; i++) {
                const it = this.createData[i];
                if(it.needUserInfo == 1&&!it.users){
                    this.$toast("请完善第"+(i+1)+"件商品的人员信息");
                    return;
                }
            }
            // return
            let goodsArr = [];
            for (let i = 0; i < this.createData.length; i++) {
                let dt = {
                    goodsId:this.createData[i].id,
                    goodsQty:this.createData[i].goodsQty,
                }
                if(this.createData[i].users){
                    dt.users = this.createData[i].users;
                }
                goodsArr.push(dt)
            }
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            let datadd = {
                addrProvince:this.address.province,
                addrCity:this.address.city,
                addrDistrict:this.address.district,
                addrStreet:this.address.street,
                addrUsername:this.address.username,
                addrTel:this.address.tel,
                userRemark:this.userRemark,
                items:goodsArr
            }
            if(this.couponObj.id){
                datadd.couponId = this.couponObj.id;
            }
            let result = await orderCreate(datadd);
            toast.clear();
            // alert(JSON.stringify(result.data))
            if(result.data.errorCode == 0){
                this.orderId = result.data.data.order.id;
                let childData = {
                    orderId:result.data.data.order.id,
                }
                if(result.data.data.order.status == 126002){
                    // console.log(231313);
                    toast.clear()
                    this.gorderDetail();
                    return false;
                }else{
                    var ua = navigator.userAgent.toLowerCase();
                    var isWeixin = ua.indexOf('micromessenger') != -1;
                    
                    if (isWeixin) {
                        this.gorderDetail();
                        toast.clear()                  
                    }else{
                        let childresult = await WxPay(childData);
                        // console.log(231311111);
                        if(childresult.data.errorCode == 0){
                            if(!childresult.data.data.code_url){
                                // alert(";;;;;;;")
                                if(childresult.data.data.mwebUrl){
                                    this.onBridgeReady(childresult.data.data);
                                }else{
                                    this.$toast(this.$t('shop.dataException'))
                                }
                                // return false
                            }else{
                                this.payShow = true;
                                setTimeout(()=>{
                                    toast.clear();
                                    document.getElementById("qrcode").innerHTML = "";
                                    new QRCode('qrcode', {
                                        width: 200,
                                        height: 200,
                                        text: childresult.data.data.code_url
                                    })
                                })
                            }
                        }else{
                            this.$toast(this.$t("shop.payInforFail"));
                        }
                    }
                }
            }else{
                this.$toast(result.data.errorMsg);
            }
        },
        onBridgeReady(data) {
            // alert(JSON.stringify(data))
            // {
            //     "appId": "wx2421b1c4370ec43b",     //公众号ID，由商户传入
            //     "timeStamp": "1395712654",     //时间戳，自1970年以来的秒数
            //     "nonceStr": "e61463f8efa94090b1f366cccfbbb444",      //随机串
            //     "package": "prepay_id=up_wx21201855730335ac86f8c43d1889123400",
            //     "signType": "RSA",     //微信签名方式：
            //     "paySign": "oR9d8PuhnIc+YZ8cBHFCwfgpaK9gd7vaRvkYD7rthRAZ\/X+QBhcCYL21N7cHCTUxbQ+EAt6Uy+lwSN22f5YZvI45MLko8Pfso0jm46v5hqcVwrk6uddkGuT+Cdvu4WBqDzaDjnNa5UK3GfE1Wfl2gHxIIY5lLdUgWFts17D4WuolLLkiFZV+JSHMvH7eaLdT9N5GBovBwu5yYKUR7skR8Fu+LozcSqQixnlEZUfyE55feLOQTUYzLmR9pNtPbPsu6WVhbNHMS3Ss2+AehHvz+n64GDmXxbX++IOBvm2olHu3PsOUGRwhudhVf7UcGcunXt8cqNjKNqZLhLw4jq\/xDg==" //微信签名
            // }
            if(!data.mwebUrl){
                WeixinJSBridge.invoke('getBrandWCPayRequest', data,
                function(res) {
                    // alert(res.err_msg)
                    // that.payType = false;
                    // that.getOrderData();
                    // this.$router.push({
                    //     path:""
                    // })
                });
            }else if(window.navigator.userAgent.indexOf('cxo2sukangbao')!==-1){
                let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
                let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if (isAndroid) {
                    // window.location.href = result.data.data.mwebUrl;

                    // window.android.JSToNative(JSON.stringify(params))
                    window.native.wxH5Pay(data.mwebUrl);
                    return false;
                } else {
                    window.webkit.messageHandlers.wxH5Pay.postMessage(data.mwebUrl)
                    return false;
                    // window.webkit.messageHandlers.JSToNative.postMessage(params)
                    // JSToNative(JSON.stringify(params))
                }
            }else{
                window.location.href = data.mwebUrl;
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
.InfoWapper{
    display: flex;
    flex-direction: column;
    .emtry{
        flex: 1;
    }
    .info-container{
        flex: 0 0 auto;
        background: #fff;
        // max-height: 70%;
        // overflow: auto;
        border-radius: 0.64rem 0.64rem 0 0;
        .info-head{
            height: 1.6rem;
            text-align: center;
            font-size: 0.64rem;
            font-weight: 500;
            color: #303133;
            line-height: 1.6rem;
            position: relative;
            .icon{
                position: absolute;
                right: 0.6rem;
                padding: 0.1rem;
                width: 0.6rem;
                top: 50%;
                transform: translate(0,-50%);
                height: 0.6rem;
                background: url("~@/assets/img/close-icon.png") no-repeat;
                background-size: 0.6rem 0.6rem;
                background-position: center;
            }
        }
        .from-container{
            max-height: 60vh;
            overflow: auto;
            padding: 0 0.6rem;
            height: auto;
            .from-item{
                margin-bottom: 0.6rem;
                .title{
                    display: flex;
                    align-items: center;
                    margin: 0.2rem 0;
                    .icon{
                        margin-right: 0.4rem;
                        width: 0.76rem;
                        height: 0.84rem;
                        background: url("~@/assets/img/info-goods-icon.png") no-repeat;
                        background-size: 100% 100%;
                        flex: 0 0 auto;
                    }
                    .txt{
                        font-size: 0.72rem;
                        font-weight: 500;
                        color: #303133;
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .from-input-item{
                    display: flex;
                    align-items: center;
                    font-size: 0.64rem;
                    padding: 0.3rem 0;
                    border-bottom: 0.02rem solid #EDEDED;
                    position: relative;
                    &::before{
                        position: absolute;
                        content: "*";
                        color: red;
                        left: -0.25rem;
                        font-size: 0.56rem;
                        top: 50%;
                        transform: translate(0,-50%);
                    }
                    .label{
                        flex: 0 0 auto;
                        width: 3rem;
                        text-align: justify;
                        text-justify:distribute-all-lines; // 这行必加，兼容ie浏览器
                        text-align-last: justify;
                        height: 1.22rem;
                        overflow: hidden;
                        line-height: 1.22rem;
                        &::after{
                            content: '';
                            width: 100%;
                            height: 0;
                            display: inline-block;
                            visibility: hidden;
                        }
                        
                    }
                    .value{
                        flex: 1;
                        padding-left: 0.2rem;
                        /deep/.van-field{
                            .van-field__control{
                                font-size: 0.64rem;
                            }
                        }
                    }
                    .icon{
                        width: .28rem;
                        height: .56rem;
                        margin-left: .4rem;
                        background: url("~@/assets/img/more-icon.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .gender{
                        display: flex;
                        align-items: center;
                        .gender-itme {
                            font-size: 0.64rem;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            color: #181818;
                            &:last-child{
                                margin-left: 1rem;
                            }
                            i{
                                width: 0.72rem;
                                margin:0 0.2rem;
                                height: 0.72rem;
                                background: #D4D7DB;
                                display: inline-block;
                                border-radius: 50%;
                                position: relative;
                                &::after{
                                    position: absolute;
                                    content: ' ';
                                    width: 0.36rem;
                                    height: 0.36rem;
                                    top: 50%;
                                    left: 50%;
                                    background: #fff;
                                    border-radius: 50%;
                                    transform: translate(-50%,-50%);
                                }
                            }

                        }
                        .genderActive{
                            i{
                                background-color: #FF5252;
                            }
                        }
                    }
                }
            }
        }
        .bottom-btn{
            padding: 0.4rem 0.6rem;
            border-top: 0.02rem solid #E4E7ED;
            box-shadow: 0 0 0.2rem #EDEDED;
            .btn{
                height: 1.6rem;
                line-height: 1.6rem;
                text-align: center;
                background: #FF5252;
                border-radius: 0.8rem;
                font-size: 0.56rem;
                font-weight: 400;
                color: #FFFFFF;
            }
        }
    }
}
.payWapper{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .wapper{
        background: #fff;
        padding: .3rem;
        border-radius: .2rem;
    }
    .bnt-close{
        background: #FF5252;
        color: #fff;
        font-size: .64rem;
        padding: .2rem 1rem;
        border-radius: .8rem;
        margin-top: 1rem;
    }
}
.create-order-main{
    background: #F5F6FA;
    height: 100%;
    display: flex;
    // padding-top: .4rem;
    font-family: PingFangSC-Regular, PingFang SC;
    flex-direction: column;
    .order-detail{
        flex: 1;
        overflow: auto;
        padding-bottom: 2rem;
        .order-address{
            padding: .8rem .6rem;
            border-radius: .32rem;
            background: url("~@/assets/img/address-back.png") no-repeat;
            background-size: 100% 100%;
            // margin-bottom: .4rem;
            box-sizing: border-box;
            // min-height: 4rem;
            display: flex;
            align-items: center;
            .addres-box{
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .address-null{
                    font-size: .6rem;
                    font-weight: 400;
                    margin: .8rem 0;
                    color: #303133;
                    display: flex;
                    align-items: center;
                    .addres-null-icon{
                        width: .52rem;
                        height: .64rem;
                        display: block;
                        margin-right: .3rem;
                        background:url("~@/assets/img/address-icon.png") no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .user-infor{
                    font-size: .6rem;
                    font-weight: 400;
                    color: #303133;
                    line-height: .84rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    .name{
                        margin-right: .2rem;
                    }
                }
                .address-text{
                    display: flex;
                    margin-top: .3rem;
                    align-items: flex-start;
                    .text-icon{
                        width: .42rem;
                        height: .52rem;
                        display: block;
                        background: url("~@/assets/img/address-icon.png") no-repeat;
                        background-size: 100% 100%;
                        margin-right: .25rem;
                        margin-top: .1rem;
                    }
                    .txt{
                        flex: 1;
                        font-size: .52rem;
                        font-weight: 400;
                        color: #303133;
                        line-height: .74rem;
                    }
                }
            }
            .more-icon{
                width: .28rem;
                height: .56rem;
                margin-left: .4rem;
                background: url("~@/assets/img/more-icon.png") no-repeat;
                background-size: 100% 100%;
            }
        }
        .order-goods{
            padding: 0 .6rem;
            background: #fff;
            overflow: hidden;
            border-radius: .32rem;
            .goods-collcapse{
                display: flex;
                align-items: center;
                padding: .5rem 0;

                .lable{
                    flex: auto 0 0;
                    text-align: left;
                    font-size: .6rem;
                    font-weight: 400;
                    display: flex;
                    align-items: center;
                    color: #303133;
                    span{
                        font-size: .4rem;
                        font-weight: 400;
                        color: #FF5252;
                        margin-left: .2rem;
                        padding: 0 .1rem;
                        border: .02rem solid #FF5252;
                        border-radius: .1rem;
                    }
                }
                .collcapse{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    .integtext{
                        color: #FF5252;
                    }
                }
            }
            .integral{
                margin: .2rem 0;
                .text{
                    float: right;
                    font-size: .52rem;
                    font-weight: 400;
                    // color: #FF5252;
                }
                .integral-icon{
                    height: .76rem;
                    height: .76rem;
                    display: inline-block;
                    background: url("~@/assets/img/active-icons.png") no-repeat center;
                    background-size: .76rem .76rem;
                }
            }
            .goods-list{
                .goods-item{
                    padding: .6rem 0;
                    border-bottom: 0.02rem solid #f5f5f5;
                    &:last-child{
                        border: 0;
                    }
                    .goods-details{
                        display: flex;
                        flex-direction: row;
                        .goods-img{
                            width: 3.28rem;
                            height: 3.28rem;
                            flex: 3.28rem 0 0;
                            margin-right: .6rem;
                            border-radius: .16rem;
                            overflow: hidden;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .goods-infor{
                            display: flex;
                            flex-direction: column;
                            flex: 1;
                            overflow: hidden;
                            .infor-text{
                                flex: 1;
                                font-size: .6rem;
                                font-weight: 400;
                                color: #303133;
                                .txt{
                                    // max-width: 100%;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    margin-bottom: .2rem;
                                    .discount-tag{
                                        font-size: 0.4rem;
                                        padding:0.06rem 0.1rem;
                                        background: #FF5252;
                                        border-radius: 0.08rem;
                                        color: #fff;
                                    }
                                }
                                .describe{
                                    font-size: .48rem;
                                    font-weight: 400;
                                    color: #909399;
                                    span{
                                        margin-right: .2rem;
                                    }
                                }
                                .back-integarl{
                                    display: flex;
                                    margin-top: .2rem;
                                    height: 0.68rem;
                                    background: #FFE9E9;
                                    align-items: center;
                                    border-radius: 0.08rem;
                                    margin-right: .2rem;
                                    width: max-content;
                                    .back{
                                        font-size: .4rem;
                                        font-weight: 500;
                                        color: #FFFFFF;
                                        line-height: .68rem;
                                        display: block;
                                        width: .68rem;
                                        height: 100%;
                                        background: #FF5252;
                                        border-radius: .08rem .24rem 0 .08rem;
                                        text-align: center;
                                        margin-right: .1rem;
                                    }
                                    .icon{
                                        width: .48rem;
                                        height: .48rem;
                                        margin-right: .1rem;
                                        background: url("~@/assets/img/back-integer-icon.png") no-repeat;
                                        background-size: 100% 100%;
                                    }
                                    .num{
                                        font-size: .4rem;
                                        font-weight: 300;
                                        color: #FF5252;
                                        line-height: .68rem;
                                        padding-right: .2rem;
                                        margin-right: 0;
                                    }
                                }
                            }
                            .price{
                                font-size: .48rem;
                                font-weight: 400;
                                color: #FF5252;
                                flex: 0 0 auto;
                                margin-top: 0.2rem;
                                span{
                                    font-size: .72rem;
                                    font-weight: bold;
                                }
                                .good-num{
                                    float: right;
                                    color: #303133;
                                    font-size: .6rem;
                                    font-weight: 400;
                                }
                            }
                            
                        }
                    }
                    .supply-info{
                        margin-top: 0.4rem;
                        display: flex;
                        padding-left: 3.88rem;
                        padding-right: 0.4rem;
                        position: relative;
                        align-items: center;
                        justify-content: space-between;
                        &::after{
                            position: absolute;
                            width: 0.28rem;
                            height: 0.56rem;
                            top: 50%;
                            content: ' ';
                            right: 0;
                            transform: translate(0,-50%);
                            background: url("~@/assets/img/more-icon.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .label{
                            flex: 0 0 auto;
                            font-size: 0.48rem;
                            font-weight: 400;
                            color: #666666;
                        }
                        .info-warning{
                            display: flex;
                            align-items: center;
                            font-size: 0.48rem;
                            font-weight: 400;
                            color: #FF5252;
                            .van-icon {
                                margin-right: 0.2rem;
                            }
                        }
                    }
                    .goodsNum{
                        .num-box{
                            display: flex;
                            align-items: center;
                            float: right;
                            .reduce-icon,.plus-icon{
                                font-size: .4rem;
                                padding: .16rem;
                                background: #DDDFE6;
                            }
                            .reduce-null{
                                background: #ECEEF5;
                                color: #C0C4CC;
                            }
                            .good-num{
                                font-size: .48rem;
                                // margin: 0 .4rem;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #303133;
                            }
                        }
                    }
                }
            }
            .goods-coupon{
                .coupon{
                    font-size: 0.52rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FF5252;
                }
                .coupon-tag{
                    display: inline-block;
                    background: #FFF0F1;
                    padding: 0.1rem 0.4rem;
                    font-size: 0.4rem;
                    color: #FF5252;
                    border-radius: 0.1rem;
                    border:1px solid #FF5252;
                    position: relative;
                    &::after,&::before{
                        width: 0.2rem;
                        height: 0.4rem;
                        content: ' ';
                        position: absolute;
                        border-radius: 50%;
                        border-left-style: solid;
                        border-color: #FF5252;
                        border-left-width: 0.02rem;
                        right: -0.05rem;
                        top: 50%;
                        transform: translate(0,-50%);
                        border: 0.03rem solid #FF5252;
                        border-right: 0;
                        border-bottom: 0;
                        background-color: #fff;
                        border-radius: 0.4rem 0 0 0.4rem;
                    }
                    &::before{
                        right: unset;
                        left: -0.05rem;
                        border: 0.03rem solid #FF5252;
                        border-left: 0;
                        border-top: 0;
                        border-radius:  0 0.4rem 0.4rem 0 ;
                    }
                }
                .arrow{
                    font-size: .52rem;
                }
            }
        }
        .order-leave-msg{
            padding: 0 .6rem;
            background: #fff;
            border-radius: .32rem;
            .msg-item{
                display: flex;
                min-height: 2rem;
                height: auto;
                border-bottom: .02rem solid #F5F6FA;
                align-items: center;

                &:last-child{
                    border: 0;
                }
                .lable{
                    flex:  0 0 auto;
                    font-size: .6rem;
                    font-weight: 400;
                    color: #303133;
                }
                .msg-section{
                    flex: 1;
                    font-size: .52rem;
                    font-weight: 400;
                    .van-cell{
                        padding: 0;
                    }
                    /deep/input{
                        font-size: .52rem;
                        line-height: .7rem;
                        margin: .4rem 0;
                    }
                }
            }
            .bill{
                .msg-section{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    .arrow {
                        margin-top: .1rem;
                    }
                }
            }
        }

    }
    .divnull{
        height: .4rem;
        width: 100%;
    }
    .order-pay{
        flex: 2.8rem 0 0;
        height: 2.8rem;
        background: #fff;
        display: flex;
        align-items: center;
        padding: .6rem .3rem;
        box-sizing: border-box;
        font-size: .56rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303133;
        border-top: .05rem solid #E4E7ED;
        .unit{
            font-size: .48rem;
            color: #FF5252;
        }
        .price{
            font-size: .84rem;
            font-weight: bold;
            color: #FF5252;
            .good-num{
                float: right;
            }
        }
        .flex{
            flex: 1;
        }
    }
    .submit{
        font-size: .52rem;
        padding: .3rem .9rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        background: #FF5252;
        color: #FFFFFF;
        border-radius: .7rem;
    }
}
.courtesy-overlay{
    .overlay-box{
        background: #FFEBEB;
        border-radius: 0.64rem 0.64rem 0 0;
        .specs-head{
            height: 2rem;
            position: relative;
            .name{
                width: 100%;
                text-align: center;
                font-size: 0.64rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #303133;
            }
            .close-icon{
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(0, -50%);
            }
        }
        .courtesy-list{
            height: 60vh;
            overflow: auto;
            .item-courtesy{
                margin-bottom: 0.6rem;
                overflow: auto;
                position: relative;
                &>div{
                    float: left;
                }
                .item-left{
                    z-index: 2;
                    margin-right: 0;
                    width: calc(100% - 1.6rem);
                    background: #FFFFFF;
                    padding:0 0.4rem;
                    position: relative;
                    border-radius: 0.64rem;
                    &::after{
                        width: 0.8rem;
                        height: 0.8rem;
                        position: absolute;
                        display: block;
                        content: ' ';
                        border-radius: 50%;
                        top: 50%;
                        transform: translate(0,-50%);
                        background: #FFEBEB;
                        left: -0.4rem;
                    }
                    &::before{
                        display: none;
                    }
          
                    .courtesy-money{
                        flex: 0 0 auto;
                        width: 3.8rem;
                        box-sizing: border-box;
                        background-position: center;
                        text-align: center;
                        padding: 0.6rem 0.4rem 0.6rem 0;
                        background: url("~@/assets/img/money-bg-icon.png") no-repeat;
                        background-size: auto 100%;
                        .moeny-num{
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 600;
                            color: #FF5252;
                            font-size: 1.4rem;
                            span{
                                font-size: 0.64rem;
                            }
                        }
                        .condition{
                            font-size: 0.4rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #FF5252;
                        }
                    }
                    .courtesy-money.maxMonery{
                        width: max-content;
                    }
                    .courtesy-info-text{
                        padding: 0 0.7rem;
                        .name{
                            font-size: 0.6rem;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #303133;
                            line-height: 0.8rem;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;				//溢出内容隐藏
                            text-overflow: ellipsis;		//文本溢出部分用省略号表示
                            display: -webkit-box;			//特别显示模式
                            -webkit-line-clamp: 2;			//行数
                            line-clamp: 2;					
                            -webkit-box-orient: vertical;	//盒子中内容竖直排列
                        }
                        .expiration-date{
                            font-size: 0.4rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #909399;
                            margin-top: 0.2rem;
                            line-height: 0.56rem;
                        }
                    }
                    .hr-line{
                        width: 0;
                        height: 2rem;
                        border-left: 0.02rem solid #909399;
                    }
                }
           
            }
        }
    }
}
</style>
